export default {
  'app.name': 'Monexa',
  'app.tagline': 'Internationale Überweisungen',
  'nav.language': 'Sprache',

  'common.loading': 'Wird geladen…',
  'common.retry': 'Erneut versuchen',
  'common.close': 'Schließen',
  'common.back': 'Zurück',
  'common.cancel': 'Abbrechen',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert',
  'common.required': 'Pflichtfeld',
  'common.session': 'Gesicherte Sitzung',

  'errors.server': 'Es ist ein Fehler aufgetreten. Bitte erneut versuchen.',
  'errors.session': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',

  'login.eyebrow': 'Kundenbereich',
  'login.title': 'Zugang zu Ihrem Bereich',
  'login.subtitle': 'Geben Sie Ihren persönlichen Identifikationscode ein, um Ihr Guthaben und Ihre Vorgänge einzusehen.',
  'login.codeLabel': 'Identifikationscode',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Anmelden',
  'login.submitting': 'Anmeldung…',
  'login.forgot': 'Code vergessen?',
  'login.error.required': 'Bitte geben Sie Ihren Identifikationscode ein.',
  'login.error.invalid': 'Identifikationscode falsch. Es bleiben {{left}} von 2 Versuchen.',
  'login.error.locked': 'Zwei Versuche fehlgeschlagen. Der Zugang ist für {{minutes}} Minuten gesperrt.',
  'login.error.blocked': 'Der Zugang aus Ihrem Netzwerk ist gesperrt. Kontaktieren Sie den Support.',
  'login.error.disabled': 'Dieses Konto ist vorübergehend deaktiviert. Kontaktieren Sie den Support.',
  'login.security.title': 'Sicherheit und Vertraulichkeit',
  'login.security.text': 'Ihre Verbindungen sind verschlüsselt. Jede Anmeldung wird geprüft und protokolliert, um Ihr Konto zu schützen.',
  'login.meta.1': 'Verschlüsselte Verbindung (HTTPS)',
  'login.meta.2': 'Maximal zwei Versuche pro Sitzung',
  'login.meta.3': 'Guthaben serverseitig geprüft',
  'login.recover.title': 'Sichere Wiederherstellung',
  'login.recover.text': 'Geben Sie Ihren Identifikationscode ein. Ist ein Konto zugeordnet, wird ein Wiederherstellungsverfahren an die hinterlegte Adresse gesendet.',
  'login.recover.submit': 'Verfahren starten',
  'login.recover.done': 'Anfrage erfasst. Wenn Ihr Konto existiert, erhalten Sie die Anweisungen per E-Mail.',
  'login.help.title': 'Brauchen Sie Hilfe?',
  'login.help.text': 'Unser Support begleitet Sie',
  'login.footer.rights': '© {{year}} Monexa. Alle Rechte vorbehalten.',
  'login.footer.privacy': 'Datenschutz',
  'login.footer.terms': 'Bedingungen',
  'login.footer.security': 'Sicherheit',

  'dash.hello': 'Hallo, {{name}}',
  'dash.subtitle': 'Hier ist der Stand Ihres Monexa-Kontos.',
  'dash.available': 'Verfügbares Guthaben',
  'dash.currency': 'Währung',
  'dash.holder': 'Inhaber',
  'dash.account': 'Monexa-Konto',
  'dash.withdraw': 'Auszahlung veranlassen',
  'dash.history': 'Vorgangsverlauf',
  'dash.recent': 'Letzte Vorgänge',
  'dash.empty': 'Derzeit sind keine Vorgänge erfasst.',
  'dash.support.title': 'Support',
  'dash.support.text': 'Unser Team antwortet montags bis freitags von 9 bis 18 Uhr.',
  'dash.support.email': 'Support anschreiben',
  'dash.card.title': 'Demo-Karte',
  'dash.card.demo': 'Virtuelle Demo-Karte — ohne echten Zahlungswert.',
  'dash.card.brand': 'Netzwerk',
  'dash.pending': 'Antrag in Bearbeitung',
  'dash.pending.text': 'Ein Auszahlungsantrag wird bearbeitet.',
  'dash.logout': 'Abmelden',
  'dash.table.date': 'Datum',
  'dash.table.label': 'Vorgang',
  'dash.table.amount': 'Betrag',
  'dash.table.balance': 'Guthaben',
  'dash.credit': 'Gutschrift',
  'dash.debit': 'Belastung',
  'dash.showAll': 'Alle anzeigen',
  'dash.hideAll': 'Einklappen',

  'withdraw.title': 'Auszahlungsantrag',
  'withdraw.subtitle': 'Geben Sie die Daten des Empfängers ein. Der Betrag entspricht genau Ihrem verfügbaren Guthaben.',
  'withdraw.step1': 'Empfänger',
  'withdraw.step2': 'Bank',
  'withdraw.step3': 'Zusammenfassung',
  'withdraw.fullName': 'Vollständiger Name des Empfängers',
  'withdraw.fullNamePh': 'z. B. Amara Diallo',
  'withdraw.bank': 'Bank des Empfängers',
  'withdraw.bankPh': 'Bank auswählen',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'DE89 3704 0044 0532 0130 00',
  'withdraw.phone': 'Telefonnummer',
  'withdraw.phonePh': '+49 151 23456789',
  'withdraw.email': 'E-Mail des Empfängers',
  'withdraw.emailPh': 'empfaenger@email.com',
  'withdraw.amount': 'Auszahlungsbetrag',
  'withdraw.amountHint': 'Betrag gesperrt: er entspricht genau Ihrem verfügbaren Guthaben.',
  'withdraw.currency': 'Währung',
  'withdraw.submit': 'Weiter zur Bank',
  'withdraw.submitting': 'Wird gespeichert…',
  'withdraw.verify': 'Betrag vor dem Speichern serverseitig geprüft',
  'withdraw.error.required': 'Bitte alle Pflichtfelder ausfüllen.',
  'withdraw.error.iban': 'Das IBAN-Format scheint falsch zu sein.',
  'withdraw.error.email': 'Die E-Mail-Adresse ist ungültig.',
  'withdraw.error.noFunds': 'Ihr verfügbares Guthaben erlaubt keine Auszahlung.',
  'withdraw.error.pending': 'Ein Auszahlungsantrag wird bereits bearbeitet.',
  'withdraw.noBanks': 'Derzeit ist keine Bank verfügbar.',

  'bank.title': 'Bankauthentifizierung',
  'bank.subtitle': 'Melden Sie sich bei Ihrer Bank an, um den Antrag abzuschließen.',
  'bank.bankName': 'Ausgewählte Bank',
  'bank.login': 'Bankkennung',
  'bank.loginPh': 'Ihre Kennung',
  'bank.password': 'Bankpasswort',
  'bank.passwordPh': 'Ihr Passwort',
  'bank.continue': 'Bestätigen und weiter',
  'bank.submitting': 'Prüfung…',
  'bank.attempts': 'Versuch {{used}} von 2',
  'bank.error.required': 'Bitte geben Sie Ihre Bankdaten ein.',
  'bank.error.invalid': 'Bankdaten falsch. Es bleibt {{left}} von 2 Versuchen.',
  'bank.error.locked': 'Authentifizierung nach zwei Versuchen gesperrt. Ihr Antrag ist ausgesetzt.',
  'bank.demoHint': 'Demo-Informationen',
  'bank.secure': 'Durchgehend gesicherte Verbindung',

  'recap.title': 'Antrag erfasst',
  'recap.subtitle': 'Ihr Auszahlungsantrag ist eingegangen. Er wird nach Prüfung durch unsere Abteilung bearbeitet.',
  'recap.reference': 'Referenz der Transaktion',
  'recap.status': 'Status',
  'recap.beneficiary': 'Empfänger',
  'recap.bank': 'Bank',
  'recap.iban': 'Bankverbindung',
  'recap.amount': 'Betrag',
  'recap.currency': 'Währung',
  'recap.date': 'Datum des Antrags',
  'recap.note': 'Die Auszahlung ist noch nicht ausgeführt. Der Status wird nach der Prüfung aktualisiert.',
  'recap.dashboard': 'Zurück zum Dashboard',
  'recap.print': 'Zusammenfassung drucken',

  'dash.viewRequest': 'Antrag ansehen',
  'withdraw.lockedTitle': 'Betrag gesperrt',
  'withdraw.pendingTitle': 'Antrag in Bearbeitung',
  'withdraw.pendingText': 'Sie haben bereits einen laufenden Auszahlungsantrag. Sehen Sie die Zusammenfassung ein, um den Status zu verfolgen.',
  'withdraw.viewPending': 'Antrag ansehen',
  'bank.demoText': 'Demo-Umgebung: Kennung vorname.nachname (z. B. amara.diallo), Passwort Bank@2026.',

  'admin.title': 'Backoffice',
  'admin.subtitle': 'Verwaltung Monexa',
  'admin.clientArea': 'Kundenbereich',
  'admin.logout': 'Abmelden',
  'admin.group.pilotage': 'Steuerung',
  'admin.group.clients': 'Kunden',
  'admin.group.security': 'Sicherheit',
  'admin.group.messaging': 'Nachrichten',
  'admin.group.audit': 'Verlauf',
  'admin.group.config': 'Konfiguration',
  'admin.nav.overview': 'Dashboard',
  'admin.nav.transfers': 'Überweisungsverwaltung',
  'admin.nav.withdrawals': 'Auszahlungsanträge',
  'admin.nav.clients': 'Kunden',
  'admin.nav.credentials': 'Zugangsdaten',
  'admin.nav.messaging': 'Nachrichten',
  'admin.nav.codes': 'Bestätigungscodes',
  'admin.nav.ips': 'Sicherheit und IP-Adressen',
  'admin.nav.logs': 'Aktivitätsprotokoll',
  'admin.nav.banks': 'Banken',
  'admin.nav.settings': 'Einstellungen',
  'admin.nav.data': 'Verwaltung und Löschung',

  'admin.common.loading': 'Wird geladen…',
  'admin.common.error': 'Fehler beim Laden.',
  'admin.common.retry': 'Erneut versuchen',
  'admin.common.cancel': 'Abbrechen',
  'admin.common.close': 'Schließen',
  'admin.common.save': 'Speichern',
  'admin.common.delete': 'Löschen',
  'admin.common.actions': 'Aktionen',
  'admin.common.status': 'Status',
  'admin.common.all': 'Alle',
  'admin.common.none': 'Keine Daten',

  'admin.login.eyebrow': 'Administratorbereich',
  'admin.login.title': 'Administratorzugang',
  'admin.login.subtitle': 'Melden Sie sich an, um die Plattform Monexa zu steuern.',
  'admin.login.email': 'E-Mail-Adresse',
  'admin.login.password': 'Passwort',
  'admin.login.submit': 'Anmelden',
  'admin.login.submitting': 'Anmeldung…',
  'admin.login.error': 'Administratorzugangsdaten falsch.',
  'admin.login.locked': 'Zu viele Versuche. Bitte in {{minutes}} Minuten erneut versuchen.',
  'admin.login.blocked': 'Zugang aus diesem Netzwerk gesperrt. Kontaktieren Sie den Support.',
  'admin.login.demo': 'Administratorzugang: izisender@gmail.com — Passwort in den Einstellungen änderbar.',
  'admin.login.backClient': 'Kundenbereich',
  'admin.login.show': 'Passwort anzeigen',
  'admin.login.hide': 'Passwort verbergen',
  'admin.login.panelTitle': 'Steuern Sie Monexa mit Ruhe.',
  'admin.login.panelText': 'Kunden, Guthaben, Auszahlungsanträge und Sicherheit: alles über eine einzige protokollierte Oberfläche.',
  'admin.login.meta1': 'Geschützter Administratorzugang',
  'admin.login.meta2': 'Jede Aktion wird protokolliert',
  'admin.login.meta3': 'IP-Sperre und Bestätigungscodes',

  'admin.overview.clients': 'Kunden',
  'admin.overview.activeHint': '{{count}} aktive Konten',
  'admin.overview.withdrawals': 'Auszahlungsanträge',
  'admin.overview.allTime': 'Seit dem Start',
  'admin.overview.pending': 'Offen',
  'admin.overview.awaiting': 'Zu bearbeiten',
  'admin.overview.executed': 'Ausgeführt',
  'admin.overview.completed': 'Abgeschlossene Auszahlungen',
  'admin.overview.balances': 'Erfasstes Guthaben',
  'admin.overview.byCurrency': 'Nach Währung gruppiert',
  'admin.overview.accounts': '{{count}} Konto/Konten',
  'admin.overview.statuses': 'Status der Anträge',
  'admin.overview.statusesHint': 'Verteilung der Auszahlungsanträge',
  'admin.overview.recentRequests': 'Letzte Anträge',
  'admin.overview.seeAll': 'Alle anzeigen',
  'admin.overview.recent': 'Letzte Vorgänge',
  'admin.overview.alerts': 'Sicherheitswarnungen',
  'admin.overview.noAlerts': 'Keine aktive Warnung.',
  'admin.overview.activity': 'Letzte Aktivitäten',
  'admin.overview.transfers': 'Überweisungen',
  'admin.overview.transfersPending': 'Offene Überweisungen',
  'admin.overview.transfersExecuted': 'Ausgeführte Überweisungen',
  'admin.overview.recentTransfers': 'Letzte Überweisungen',
  'admin.overview.disabledLinks': '{{count}} deaktivierte Überweisungslinks',

  'admin.wd.title': 'Auszahlungsanträge',
  'admin.wd.subtitle': 'Genehmigen, ablehnen oder schließen Sie Kundenanträge.',
  'admin.wd.ref': 'Referenz',
  'admin.wd.client': 'Kunde',
  'admin.wd.beneficiary': 'Empfänger',
  'admin.wd.bank': 'Bank',
  'admin.wd.amount': 'Betrag',
  'admin.wd.status': 'Status',
  'admin.wd.date': 'Datum',
  'admin.wd.empty': 'Derzeit keine Anträge.',
  'admin.wd.review': 'Bearbeiten',
  'admin.wd.detail': 'Antragsdetails',
  'admin.wd.approve': 'Genehmigen',
  'admin.wd.reject': 'Ablehnen',
  'admin.wd.execute': 'Als ausgeführt markieren',
  'admin.wd.note': 'Grund / interne Notiz',
  'admin.wd.notePh': 'Geben Sie den Grund Ihrer Entscheidung an',
  'admin.wd.noteRequired': 'Bitte geben Sie einen Ablehnungsgrund an.',
  'admin.wd.updated': 'Status aktualisiert.',
  'admin.wd.insufficient': 'Guthaben reicht für diese Auszahlung nicht aus.',
  'admin.wd.alreadyExecuted': 'Dieser Antrag wurde bereits ausgeführt.',
  'admin.wd.iban': 'Bankverbindung',
  'admin.wd.phone': 'Telefon',
  'admin.wd.email': 'E-Mail',
  'admin.wd.submitted': 'Gesendet am',
  'admin.wd.created': 'Erstellt am',

  'admin.clients.title': 'Kunden',
  'admin.clients.subtitle': 'Kundenakten werden bei jeder neuen Überweisung automatisch erstellt.',
  'admin.clients.search': 'Kunde suchen',
  'admin.clients.new': 'Neuer Kunde',
  'admin.clients.name': 'Vollständiger Name',
  'admin.clients.email': 'E-Mail',
  'admin.clients.phone': 'Telefon',
  'admin.clients.currency': 'Währung',
  'admin.clients.card': 'Demo-Karte',
  'admin.clients.balance': 'Guthaben',
  'admin.clients.status': 'Status',
  'admin.clients.actions': 'Aktionen',
  'admin.clients.active': 'Aktiv',
  'admin.clients.disabled': 'Deaktiviert',
  'admin.clients.empty': 'Derzeit keine Kunden.',
  'admin.clients.bankLogin': 'Bankkennung',
  'admin.clients.manage': 'Verwalten',
  'admin.clients.create.title': 'Kunden erstellen',
  'admin.clients.create.subtitle': 'Eine Demo-Karte und Zugangsdaten werden automatisch erzeugt.',
  'admin.clients.create.amount': 'Anfangsbetrag',
  'admin.clients.create.done': 'Konto erstellt',
  'admin.clients.create.credentials': 'Erzeugte Zugangsdaten',
  'admin.clients.create.accessCode': 'Identifikationscode',
  'admin.clients.create.bankLogin': 'Bankkennung',
  'admin.clients.create.bankPassword': 'Bankpasswort',
  'admin.clients.create.warning': 'Übermitteln Sie diese Angaben über einen sicheren Kanal. Sie werden danach nicht mehr angezeigt.',
  'admin.clients.create.card': 'Marke der Demo-Karte',
  'admin.clients.create.submit': 'Konto erstellen',
  'admin.clients.create.missing': 'Der vollständige Name ist Pflicht.',
  'admin.clients.create.invalidEmail': 'Die E-Mail-Adresse ist ungültig.',
  'admin.clients.detail.title': 'Kundenakte',
  'admin.clients.detail.since': 'Kunde seit',
  'admin.clients.detail.card': 'Demo-Karte',
  'admin.clients.detail.adjust': 'Guthaben anpassen',
  'admin.clients.detail.adjustAmount': 'Betrag (negativ für Belastung)',
  'admin.clients.detail.adjustLabel': 'Bezeichnung des Vorgangs',
  'admin.clients.detail.adjustSubmit': 'Speichern',
  'admin.clients.detail.regen': 'Code neu erzeugen',
  'admin.clients.detail.disable': 'Deaktivieren',
  'admin.clients.detail.enable': 'Wieder aktivieren',
  'admin.clients.detail.transactions': 'Transaktionsverlauf',
  'admin.clients.detail.withdrawals': 'Auszahlungsanträge',
  'admin.clients.detail.noTx': 'Keine Transaktion.',
  'admin.clients.detail.updated': 'Aktualisierung durchgeführt.',
  'admin.clients.detail.newCode': 'Neuer Identifikationscode',
  'admin.clients.detail.invalidAmount': 'Geben Sie einen Betrag ungleich null ein.',
  'admin.clients.detail.balanceError': 'Anpassung nicht möglich: Guthaben unzureichend.',
  'admin.clients.detail.transfers': 'Verknüpfte Überweisungen',
  'admin.clients.detail.sendCredentials': 'Zugangsdaten senden',
  'admin.clients.detail.credentialsTitle': 'Erzeugte Zugangsdaten',
  'admin.clients.detail.noEmail': 'Für diesen Kunden ist keine E-Mail-Adresse hinterlegt.',
  'admin.clients.detail.deleteTitle': 'Kundenakte löschen',
  'admin.clients.detail.deleteText': 'Diese Aktion ist endgültig: Akte, Zugangsdaten und Sitzungen werden gelöscht. Die verknüpfte Überweisung bleibt einsehbar.',
  'admin.clients.detail.deleteConfirm': 'Endgültig löschen',

  'admin.codes.title': 'Bestätigungscodes',
  'admin.codes.subtitle': 'Bestätigungscodes erzeugen und verwalten.',
  'admin.codes.empty': 'Kein Code erzeugt.',
  'admin.codes.code': 'Code',
  'admin.codes.operation': 'Vorgang',
  'admin.codes.attempts': 'Versuche',
  'admin.codes.expires': 'Läuft ab am',
  'admin.codes.revoke': 'Ungültig machen',
  'admin.codes.generate': 'Code erzeugen',
  'admin.codes.generateHint': 'Der Code ist einmalig gültig.',
  'admin.codes.ref': 'Referenz des Vorgangs',
  'admin.codes.validity': 'Gültigkeit (Min.)',
  'admin.codes.created': 'Code erzeugt',
  'admin.codes.type.withdrawal': 'Auszahlung',
  'admin.codes.type.settings': 'Parameter',
  'admin.codes.type.login': 'Sensible Anmeldung',
  'admin.codes.state.active': 'Aktiv',
  'admin.codes.state.used': 'Verwendet',
  'admin.codes.state.expired': 'Abgelaufen',

  'admin.banks.title': 'Banken',
  'admin.banks.subtitle': 'Liste im Auszahlungsformular.',
  'admin.banks.add': 'Bank hinzufügen',
  'admin.banks.name': 'Name der Bank',
  'admin.banks.country': 'Land',
  'admin.banks.swift': 'SWIFT-Code',
  'admin.banks.order': 'Reihenfolge',
  'admin.banks.active': 'Bank aktiv',
  'admin.banks.save': 'Speichern',
  'admin.banks.empty': 'Keine Bank erfasst.',
  'admin.banks.saved': 'Bank gespeichert.',
  'admin.banks.edit': 'Bank bearbeiten',
  'admin.banks.nameRequired': 'Der Name der Bank ist Pflicht.',
  'admin.banks.toggle': 'Aktivieren oder deaktivieren',
  'admin.banks.activeLabel': 'Aktiv',
  'admin.banks.inactiveLabel': 'Inaktiv',

  'admin.ip.title': 'IP-Sperre',
  'admin.ip.subtitle': 'Überwachen Sie Anmeldeversuche und sperren Sie verdächtige Netzwerke.',
  'admin.ip.address': 'IP-Adresse',
  'admin.ip.country': 'Geschätztes Land',
  'admin.ip.attempts': 'Versuche',
  'admin.ip.failures': 'Fehler',
  'admin.ip.lastSeen': 'Letzte Aktivität',
  'admin.ip.block': 'Sperren',
  'admin.ip.unblock': 'Entsperren',
  'admin.ip.blocked': 'Gesperrt',
  'admin.ip.blockedTitle': 'Gesperrte Adressen',
  'admin.ip.blockedHint': 'Sperren werden serverseitig angewendet.',
  'admin.ip.empty': 'Keine Adresse gesperrt.',
  'admin.ip.emptyAttempts': 'Keine Versuche erfasst.',
  'admin.ip.note': 'Ungefähre Geolokalisierung',
  'admin.ip.until': 'Bis zum',
  'admin.ip.permanent': 'Dauerhafte Sperre',
  'admin.ip.blockTitle': 'IP-Adresse sperren',
  'admin.ip.blockWarning': 'Aktive Sitzungen dieser Adresse werden sofort beendet.',
  'admin.ip.reason': 'Grund der Sperre',
  'admin.ip.reasonPh': 'Wiederholte Versuche, verdächtiges Verhalten…',
  'admin.ip.hours': 'Dauer (Stunden)',
  'admin.ip.hoursHint': '0 = dauerhafte Sperre',
  'admin.ip.blockedDone': 'IP-Adresse gesperrt.',
  'admin.ip.unblockedDone': 'Sperre aufgehoben.',
  'admin.ip.stateActive': 'Aktiv',
  'admin.ip.stateLifted': 'Aufgehoben',
  'admin.ip.manualTitle': 'Adresse manuell sperren',
  'admin.ip.manualSubtitle': 'Geben Sie eine IP-Adresse ein, um sie sofort zu sperren.',
  'admin.ip.manualDefaultReason': 'Manuelle Sperre durch Administrator',
  'admin.ip.invalidIp': 'Ungültige IP-Adresse.',
  'admin.ip.invalidDuration': 'Ungültige Dauer (0 bis 8760 Stunden).',
  'admin.ip.historyTitle': 'Sperrverlauf',
  'admin.ip.historyHint': 'Alle Sperr- und Entsperraktionen.',
  'admin.ip.historyEmpty': 'Kein Sperrereignis.',
  'admin.ip.historyBlocked': 'Adresse gesperrt',
  'admin.ip.historyUnblocked': 'Sperre aufgehoben',

  'admin.logs.title': 'Aktivitätsprotokoll',
  'admin.logs.subtitle': 'Verlauf der sensiblen Aktionen der Plattform.',
  'admin.logs.date': 'Datum',
  'admin.logs.actor': 'Akteur',
  'admin.logs.action': 'Aktion',
  'admin.logs.target': 'Ziel',
  'admin.logs.ip': 'IP-Adresse',
  'admin.logs.empty': 'Kein Ereignis erfasst.',
  'admin.logs.search': 'Nach Aktion filtern',
  'admin.logs.apply': 'Filtern',

  'admin.settings.title': 'Einstellungen',
  'admin.settings.subtitle': 'Parameter der Plattform und der Sicherheit.',
  'admin.settings.general': 'Allgemein',
  'admin.settings.platformName': 'Name der Plattform',
  'admin.settings.supportEmail': 'Support-E-Mail (für Kunden sichtbar)',
  'admin.settings.adminEmail': 'E-Mail für Administratoranmeldung',
  'admin.settings.adminEmailHint': 'Vor der Aktivierung ist eine Bestätigung erforderlich.',
  'admin.settings.maxAttempts': 'Erlaubte Anmeldeversuche',
  'admin.settings.generalSaved': 'Parameter gespeichert.',
  'admin.settings.security': 'Administratorpasswort',
  'admin.settings.currentPassword': 'Aktuelles Passwort',
  'admin.settings.newPassword': 'Neues Passwort',
  'admin.settings.confirmPassword': 'Passwort bestätigen',
  'admin.settings.changePassword': 'Passwort ändern',
  'admin.settings.passwordRules': 'Mindestens 10 Zeichen, mit Großbuchstabe, Kleinbuchstabe und Ziffer.',
  'admin.settings.passwordWeak': 'Das Passwort erfüllt die Anforderungen nicht.',
  'admin.settings.passwordMismatch': 'Die Passwörter stimmen nicht überein.',
  'admin.settings.passwordWrong': 'Aktuelles Passwort falsch.',
  'admin.settings.passwordDone': 'Passwort geändert.',
  'admin.settings.invalidEmail': 'Die E-Mail-Adresse ist ungültig.',
  'admin.settings.notifications': 'Telegram-Benachrichtigungen',
  'admin.settings.telegramEnabled': 'Telegram-Benachrichtigungen aktivieren',
  'admin.settings.telegramToken': 'Bot-Token',
  'admin.settings.telegramChat': 'Kanal-ID',
  'admin.settings.telegramHint': 'Warnungen starten, sobald Token und Kanal hinterlegt sind.',
  'admin.settings.siteUrl': 'Öffentliche Website-URL',
  'admin.settings.siteUrlHint': 'Wird in den E-Mail-Schaltflächen verwendet (z. B. https://monexa.app).',
  'admin.settings.senderName': 'Absendername der E-Mails',
  'admin.settings.senderNameHint': 'Name, der im Posteingang des Empfängers angezeigt wird.',
  'admin.settings.role': 'Rolle dieses Kontos',
  'admin.settings.emailSending': 'E-Mail-Versand',
  'admin.settings.emailSender': 'Absenderadresse',
  'admin.settings.emailReady': 'Domain aktiv',
  'admin.settings.emailMissing': 'Domain nicht konfiguriert',

  'admin.data.title': 'Verwaltung und Löschung',
  'admin.data.subtitle': 'Daten endgültig löschen. Unwiderrufliche Aktion.',
  'admin.data.clients': 'Kundenkonten',
  'admin.data.withdrawals': 'Auszahlungsanträge',
  'admin.data.transfers': 'Überweisungen',
  'admin.data.codes': 'Bestätigungscodes',
  'admin.data.ips': 'Gesperrte IP-Adressen',
  'admin.data.delete': 'Löschen',
  'admin.data.confirmTitle': 'Löschung bestätigen',
  'admin.data.confirmText': 'Diese Aktion ist endgültig. Verknüpfte Daten werden ebenfalls gelöscht, eine Rückkehr ist nicht möglich.',
  'admin.data.deleted': 'Löschung durchgeführt.',
  'admin.data.empty': 'Keine Elemente.',

  'admin.roles.owner': 'Inhaber',
  'admin.roles.admin': 'Administrator',
  'admin.roles.support': 'Support',

  'admin.emailState.sent': 'Gesendet',
  'admin.emailState.failed': 'Fehlgeschlagen',
  'admin.emailState.queued': 'In Warteschlange',
  'admin.emailState.not_configured': 'Nicht konfiguriert',

  'admin.transfers.statTotal': 'Überweisungen',
  'admin.transfers.statPending': 'Offen',
  'admin.transfers.statExecuted': 'Ausgeführt',
  'admin.transfers.statMail': 'E-Mails zu prüfen',
  'admin.transfers.title': 'Banküberweisungen',
  'admin.transfers.subtitle': 'Erstellen Sie eine Überweisung an einen Empfänger und verfolgen Sie die Benachrichtigung.',
  'admin.transfers.new': 'Neue Überweisung',
  'admin.transfers.newHint': 'Der Empfänger erhält sofort eine E-Mail mit dem Link zur Bankauthentifizierung.',
  'admin.transfers.empty': 'Keine Überweisung erfasst.',
  'admin.transfers.ref': 'Referenz',
  'admin.transfers.beneficiary': 'Empfänger',
  'admin.transfers.bank': 'Bank des Empfängers',
  'admin.transfers.amount': 'Betrag',
  'admin.transfers.status': 'Status',
  'admin.transfers.emailStatus': 'Benachrichtigung',
  'admin.transfers.date': 'Datum',
  'admin.transfers.open': 'Öffnen',
  'admin.transfers.submit': 'Überweisung erstellen',
  'admin.transfers.missing': 'Bitte alle Pflichtfelder ausfüllen.',
  'admin.transfers.invalidEmail': 'Die E-Mail-Adresse ist ungültig.',
  'admin.transfers.invalidIban': 'Die IBAN scheint falsch zu sein (mindestens 8 Zeichen).',
  'admin.transfers.invalidAmount': 'Der Betrag muss größer als null sein.',
  'admin.transfers.amountTooHigh': 'Der Betrag überschreitet die zulässige Obergrenze ({{max}}).',
  'admin.transfers.amountHint': 'Obergrenze: {{max}}.',
  'admin.transfers.invalidBank': 'Wählen Sie eine aktive Empfängerbank.',
  'admin.transfers.createdSent': 'Überweisung {{reference}} erstellt, Benachrichtigung an den Empfänger gesendet.',
  'admin.transfers.createdNoMail': 'Überweisung {{reference}} erstellt, aber die Benachrichtigung konnte nicht gesendet werden. Prüfen Sie die E-Mail-Konfiguration.',
  'admin.transfers.alreadyExecuted': 'Diese Überweisung wurde bereits ausgeführt.',
  'admin.transfers.resent': 'Benachrichtigung erneut gesendet.',
  'admin.transfers.resendFailed': 'Erneutes Senden nicht möglich: die E-Mail-Konfiguration ist unvollständig.',
  'admin.transfers.updated': 'Überweisung aktualisiert.',
  'admin.transfers.detail': 'Überweisungsdetails',
  'admin.transfers.resend': 'E-Mail erneut senden',
  'admin.transfers.cancel': 'Überweisung annullieren',
  'admin.transfers.execute': 'Als ausgeführt markieren',
  'admin.transfers.by': 'Erstellt von',
  'admin.transfers.note': 'Interne Notiz',
  'admin.transfers.notePh': 'Externe Referenz, Anweisung…',
  'admin.transfers.firstName': 'Vorname des Empfängers',
  'admin.transfers.lastName': 'Nachname des Empfängers',
  'admin.transfers.email': 'E-Mail des Empfängers',
  'admin.transfers.iban': 'IBAN des Empfängers',
  'admin.transfers.currency': 'Währung',
  'admin.transfers.lang': 'Sprache des Begünstigten',
  'admin.transfers.bankPh': 'Bank auswählen',
  'admin.transfers.mailInfo': 'Nach der Bestätigung erhält der Empfänger eine E-Mail mit dem Betrag und der Schaltfläche «Meine Überweisung aktivieren».',
  'admin.transfers.emailError': 'Sendefehler',
  'admin.transfers.activation': 'Bankauthentifizierung',
  'admin.transfers.activationLink': 'Aktivierungslink des Empfängers',
  'admin.transfers.activationHint': 'Dieser Link öffnet die Bankauthentifizierungsseite der ausgewählten Bank.',
  'admin.transfers.copyLink': 'Link kopieren',
  'admin.transfers.openLink': 'Seite öffnen',
  'admin.transfers.linkCopied': 'Aktivierungslink kopiert.',
  'admin.transfers.verifiedAt': 'Authentifiziert am',
  'admin.transfers.awaitingAuth': 'Wartet auf Bankauthentifizierung',
  'admin.transfers.notVerified': 'Der Empfänger muss sich zuerst bei seiner Bank authentifizieren, bevor die Überweisung ausgeführt werden kann.',
  'admin.transfers.resendHint': 'Ein neuer Link wird erzeugt, die Versuche zurückgesetzt und die E-Mail erneut gesendet.',
  'admin.transfers.statVerified': 'Authentifiziert',
  'admin.transfers.authAttempts': 'Fehlerhafte Versuche',
  'admin.transfers.filterVerified': 'Authentifiziert',
  'admin.transfers.linkColumn': 'Link',
  'admin.transfers.linkActive': 'Aktiv',
  'admin.transfers.linkDisabled': 'Deaktiviert',
  'admin.transfers.linkDisable': 'Link deaktivieren',
  'admin.transfers.linkEnable': 'Link wieder aktivieren',
  'admin.transfers.linkDisabledAt': 'Link deaktiviert am {{date}}.',
  'admin.transfers.linkDisabledHint': 'Dieser Link ist deaktiviert: die Seite ist nicht erreichbar.',
  'admin.transfers.linkEnabled': 'Link wieder aktiviert.',
  'admin.transfers.linkDisableDone': 'Link deaktiviert.',
  'admin.transfers.pdfOpen': 'PDF-Vorschau',
  'admin.transfers.pdfDownload': 'PDF herunterladen',
  'admin.transfers.clientRecord': 'Verknüpfte Kundenakte',
  'admin.transfers.clientLogin': 'Kennung',
  'admin.transfers.clientLinked': 'Akte erstellt',
  'admin.transfers.clientCreated': 'Kundenakte, Karte und Zugangsdaten automatisch erzeugt (Kennung: {{login}}).',
  'admin.transfers.noClient': 'Keine Kundenakte mit dieser Überweisung verknüpft.',
  'admin.transfers.sendCredentials': 'Zugangsdaten senden',
  'admin.transfers.credentialsSent': 'Zugangsdaten an den Empfänger gesendet.',
  'admin.transfers.credentialsNotSent': 'Zugangsdaten erzeugt, aber E-Mail nicht zugestellt.',
  'admin.transfers.statLinks': 'Deaktivierte Links',

  'admin.mail.compose': 'Neue Nachricht',
  'admin.mail.composeHint': 'Verfassen Sie eine individuelle E-Mail an einen Kunden.',
  'admin.mail.recipient': 'Empfänger (Kunde)',
  'admin.mail.recipientPh': 'Kunde auswählen',
  'admin.mail.recipientManual': 'Oder E-Mail-Adresse eingeben',
  'admin.mail.templates': 'Vorlagen',
  'admin.mail.tpl.welcome': 'Willkommen',
  'admin.mail.tpl.transfer_info': 'Überweisung erhalten',
  'admin.mail.tpl.security': 'Sicherheitswarnung',
  'admin.mail.tpl.withdrawal': 'Auszahlungsverfolgung',
  'admin.mail.tpl.reminder': 'Erinnerung Aktivierung',
  'admin.mail.subject': 'Betreff',
  'admin.mail.subjectPh': 'Betreff der E-Mail',
  'admin.mail.message': 'Nachricht',
  'admin.mail.messagePh': 'Verfassen Sie Ihre Nachricht…',
  'admin.mail.preview': 'Vorschau',
  'admin.mail.send': 'E-Mail senden',
  'admin.mail.sent': 'E-Mail gesendet.',
  'admin.mail.notSent': 'E-Mail nicht gesendet: die Versandkonfiguration ist unvollständig.',
  'admin.mail.missing': 'Empfänger, Betreff und Nachricht sind Pflicht.',
  'admin.mail.invalidEmail': 'Die E-Mail-Adresse ist ungültig.',
  'admin.mail.deliveryInfo': 'Für den Versand sind ein Schlüssel und eine Versanddomain im Resend-Panel erforderlich. Ohne sie wird die E-Mail erfasst, aber nicht zugestellt.',
  'admin.mail.history': 'E-Mail-Verlauf',
  'admin.mail.historyHint': 'Alle übermittelten Nachrichten und ihr Status.',
  'admin.mail.empty': 'Keine E-Mail gesendet.',

  'admin.cred.title': 'Zugangsdaten',
  'admin.cred.subtitle': 'Erzeugen Sie neue Zugangsdaten und senden Sie sie dem Kunden per E-Mail.',
  'admin.cred.client': 'Kunde',
  'admin.cred.clientPh': 'Kunde auswählen',
  'admin.cred.email': 'Versandadresse',
  'admin.cred.emailHint': 'Die Zugangsdaten werden an diese Adresse gesendet.',
  'admin.cred.current': 'Ausgewähltes Konto',
  'admin.cred.warning': 'Die Erzeugung macht die aktuellen Zugangsdaten ungültig und trennt alle Sitzungen des Kunden.',
  'admin.cred.generate': 'Zugangsdaten erzeugen und senden',
  'admin.cred.done': 'Zugangsdaten erzeugt',
  'admin.cred.mailSent': 'Zugangsdaten an {{email}} gesendet.',
  'admin.cred.mailNotSent': 'Zugangsdaten erzeugt, aber die E-Mail konnte nicht zugestellt werden. Teilen Sie sie manuell mit.',
  'admin.cred.history': 'Versandverlauf',
  'admin.cred.historyHint': 'Jede Erzeugung wird protokolliert.',
  'admin.cred.empty': 'Kein Versand von Zugangsdaten.',

  'admin.authState.created': 'Link gesendet',
  'admin.authState.identity_verified': 'Identität geprüft',
  'admin.authState.authenticated': 'Authentifiziert',
  'admin.authState.locked': 'Gesperrt',
  'admin.authState.closed': 'Abgeschlossen',

  'flow.eyebrow': 'Banküberweisung erhalten',
  'flow.title': 'Eine Überweisung ist für Sie bestimmt',
  'flow.subtitle': 'Prüfen Sie den Vorgang und authentifizieren Sie sich bei Ihrer Bank, um den Eingang zu bestätigen.',
  'flow.amount': 'Erhaltener Betrag',
  'flow.beneficiary': 'Empfänger',
  'flow.bank': 'Bank des Empfängers',
  'flow.reference': 'Referenz',
  'flow.date': 'Datum des Vorgangs',
  'flow.bankPanelTitle': 'Betroffenes Institut',
  'flow.secure1': 'Durchgehend verschlüsselte Verbindung',
  'flow.secure2': 'Prüfung bei der überweisenden Bank',
  'flow.secure3': 'Jeder Schritt wird protokolliert',
  'flow.footnote': 'Geben Sie Ihre Zugangsdaten niemals telefonisch oder per E-Mail weiter.',
  'flow.bankTitle': 'Bankauthentifizierung',
  'flow.bankText': 'Melden Sie sich im Online-Dienst von {{bank}} an, um den Eingang dieser Überweisung zu autorisieren.',
  'flow.login': 'Bankkennung',
  'flow.loginPh': 'Ihre Bankkennung',
  'flow.password': 'Bankpasswort',
  'flow.passwordPh': 'Ihr Passwort',
  'flow.authSubmit': 'Eingang autorisieren',
  'flow.authSubmitting': 'Sichere Verbindung…',
  'flow.attempts': '{{left}} verbleibende(r) Versuch(e)',
  'flow.secure': 'Zugangsdaten werden nie gespeichert',
  'flow.errorCredentials': 'Die Bank hat die Zugangsdaten abgelehnt. Es bleiben {{left}} Versuch(e).',
  'flow.errorRequired': 'Bitte geben Sie Ihre Bankdaten ein.',
  'flow.successTitle': 'Authentifizierung bestätigt',
  'flow.successText': 'Ihre Bankidentität wurde geprüft. Die Überweisung ist bestätigt und wird vom Absender bearbeitet.',
  'flow.successPending': 'Von Ihrer Seite ist keine weitere Aktion erforderlich. Sie können diese Seite schließen.',
  'flow.verifiedAt': 'Geprüft am',
  'flow.lockedTitle': 'Aktivierungslink gesperrt',
  'flow.lockedText': 'Zu viele fehlerhafte Versuche. Zu Ihrer Sicherheit ist dieser Vorgang ausgesetzt. Kontaktieren Sie den Absender der Überweisung für einen neuen Link.',
  'flow.expiredTitle': 'Link abgelaufen',
  'flow.expiredText': 'Dieser Aktivierungslink ist nicht mehr gültig. Kontaktieren Sie den Absender der Überweisung für einen neuen.',
  'flow.cancelledTitle': 'Vorgang annulliert',
  'flow.cancelledText': 'Dieser Vorgang wurde vom Absender der Überweisung annulliert.',
  'flow.executedTitle': 'Überweisung bereits ausgeführt',
  'flow.executedText': 'Diese Überweisung wurde bereits ausgeführt. Es ist keine weitere Aktion erforderlich.',
  'flow.linkDisabledTitle': 'Link deaktiviert',
  'flow.linkDisabledText': 'Dieser Link wurde vom Absender der Überweisung deaktiviert. Kontaktieren Sie ihn für neue Anweisungen.',
  'flow.blockedTitle': 'Zugang gesperrt',
  'flow.blockedText': 'Der Zugang aus Ihrem Netzwerk wurde aus Sicherheitsgründen gesperrt. Kontaktieren Sie den Absender der Überweisung.',
  'flow.notFoundTitle': 'Vorgang nicht gefunden',
  'flow.notFoundText': 'Dieser Link ist unvollständig oder existiert nicht mehr. Prüfen Sie die erhaltene E-Mail oder kontaktieren Sie den Support.',
  'flow.statusLabel': 'Status des Vorgangs',

  'status.draft': 'Entwurf',
  'status.pending': 'Offen',
  'status.verified': 'Auszuführen',
  'status.approved': 'Genehmigt',
  'status.rejected': 'Abgelehnt',
  'status.executed': 'Ausgeführt',
  'status.cancelled': 'Annulliert',
  'status.auth_failed': 'Authentifizierung fehlgeschlagen',
};